module.exports = __webpack_public_path__ + "media/images/emblems/Blason_commune_CH_Corcelles-pres-Payerne_(Vaud)-52a506566c6fc8790ee8632810ff12a2.svg";